import moment from 'moment';

export const date = (input) => {
  let dateComp = moment(input, "MM/DD/YYYY", true);
  return dateComp.isValid();
};

